import { Show } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { InsolvenzUI } from 'components/profiles';
import React from 'react';
import { UnternehmenDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

interface InsolvenzProps 
{
  unternehmen: UnternehmenDto;
}

const Insolvenz: React.FC<InsolvenzProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');
    
  return (
    <>

      <Show when={unternehmen.insolvenzen.length > 0}>
        <ul className="no-list-style">
          <ContentRow id="insolvenz" title={t('profiles:unternehmen.insolvenz.label')}>
            {unternehmen.insolvenzen.map((insolvenz) => (
              <InsolvenzUI key={insolvenz.ediktId} insolvenz={insolvenz} />
            ))}
          </ContentRow>
        </ul>
      </Show>

    </>
  );
};

export default Insolvenz;
